

























import Vue from 'vue'
import { computed } from '@vue/composition-api'
import getItems, { Item } from './config'
import { currentNode } from '@/assets/node'
// import { updateByField } from '@/assets/util'
import { isEdit } from '@/assets/render'

export default {
  setup () {
    const list = computed(() => {
      if (currentNode.value) {
        return getItems(currentNode.value.outDocFlow)
      }
      return []
    })
    const handleReset = () => {
      currentNode.value!.quickToolsAddClass = []
    }
    const handleClick = (item: Item) => {
      if (currentNode.value) {
        if (!currentNode.value.quickToolsAddClass) {
          Vue.set(currentNode.value, 'quickToolsAddClass', [])
        }
        const index = currentNode.value.quickToolsAddClass.findIndex((x: string) => x === item.class)
        if (index > -1) {
          currentNode.value.quickToolsAddClass.splice(index, 1)
        } else {
          currentNode.value.quickToolsAddClass.push(item.class)
        }
      }
    }
    const hasSelect = (cls: string) => {
      if (currentNode.value && currentNode.value.quickToolsAddClass) {
        return currentNode.value.quickToolsAddClass.includes(cls)
      }
    }

    return {
      currentNode,
      list,
      isEdit,
      handleClick,
      handleReset,
      hasSelect
    }
  }
}
